import React, { useEffect, useState } from 'react'
import { Box, display } from '@mui/system'
import { CircularProgress, Drawer, Grid, IconButton, Paper, Stack, TextField, Typography } from '@mui/material'
import { useDispatch } from 'react-redux'
import SearchIcon from '@mui/icons-material/Search';
import CandidateSideBar from '../Candidate/Profile/CandidateSideBar'
import Navbar from '../Navbar'
import companyLogo from '../../images/companyLogo.jpg'
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import { useNavigate } from 'react-router-dom';
import { getAllJobs } from '../../actions/userAuth';
import Layout from '../../assets/Layout';
import UserLayout from '../../assets/UserLayout';

export default function RecommandedJob() {
    const [user, setUser] = useState("");
    const [isDrawerOpen, setIsDrawerOpen] = useState(true);
    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    // const handleDrawerToggle = () => {
    //     setIsDrawerOpen(!isDrawerOpen);
    // };

    // useEffect(() => {
    //     if (localStorage.getItem("refreshToken")) {
    //         dispatch(getUserInformation({}, (data) => {
    //             dispatch({
    //                 type: "LOG_IN",
    //                 payload: data.data.data,
    //             });
    //             localStorage.setItem("user", JSON.stringify(data.data.data));
    //             setUser(data.data.data);
    //         }, (err) => {
    //             console.log(err);
    //         }, localStorage.getItem("refreshToken")
    //         ))
    //     }
    // }, []);

    const handleSearch = (event) => {
        const searchTerm = event.target.value;
    };

    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        dispatch(getAllJobs({}, (data) => {
            setLoading(false);
            setJobs(data.data);
        }, (err) => {
            setLoading(false);
        }));
    }, []);

    const DaysAgo = (date) => {
        if (date) {
            const inputDate = new Date(date);
            const currentDate = new Date();
            const timeDifference = currentDate.getTime() - inputDate.getTime();
            const daysAgo = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            return daysAgo;
        }
    }

    return (
        <>
            <Layout>
                <UserLayout>
                    <Box sx={{ display: 'flex', flexDirection: 'row', my: 8, borderRadius: '10px' }}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', width: '100%' }}>Recommended Job</Typography>
                        <TextField
                            sx={{ background: '#3665D014', width: '70%', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)', }} // Updated style
                            variant="outlined"
                            size="small"
                            placeholder="Search"
                            onChange={handleSearch}
                            InputProps={{
                                endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                            }}
                        />
                    </Box>

                    <Grid container spacing={2}>
                        {
                            loading
                                ?
                                <Grid item xs={12}>
                                    <span style={{ verticalAlign: 'middle' }}>
                                        <CircularProgress /> Loading
                                    </span>
                                </Grid>
                                :
                                jobs.map((item, index) => (
                                    <Grid item key={index} md={6}>
                                        <Paper>
                                            <Grid container py={2} px={2}>
                                                <Grid item md={3} >
                                                    <img src={item?.logoUrl} style={{ borderRadius: '1rem' }} width={'100%'} alt='image' />
                                                </Grid>
                                                <Grid item md={7} px={2}>
                                                    <Stack>
                                                        <Typography variant="body2" className='tex2Bold' sx={{ fontWeight: 'bold', cursor: 'pointer' }} onClick={() => navigate(`/job-details/${item._id}`)}>{item?.jobTitle}</Typography>
                                                        <Typography variant="caption" className='tex2Bold' sx={{ fontWeight: 'bold', width: '100%' }}>{item?.companyName}</Typography>
                                                        <Typography variant="caption" className='tex2Bold' sx={{ fontWeight: 'bold', width: '100%', opacity: '0.5' }}>{item?.city}, {item?.state}, {item?.country} </Typography>
                                                        <Typography variant="caption" className='tex2Bold' sx={{ fontWeight: 'bold', width: '100%', color: '#2544EE' }}>{item?.companyWebsite}</Typography>
                                                    </Stack>
                                                </Grid>
                                                <Grid item md={2} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                                    <BookmarkBorderIcon sx={{ ml: '75%' }} />
                                                    <Typography variant="caption" className='tex2Bold' sx={{ fontWeight: 'bold', width: '100%', color: '#41B249', mt: 5 }}>{DaysAgo(item?.createdAt) == 0 ? "Today" : `${DaysAgo(item?.createdAt)} days ago`}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                ))
                        }
                    </Grid>
                </UserLayout>
            </Layout>
        </>
    )
}
